import {HStack, Show, Space} from 'platform/foundation';

import {ReactNode} from 'react';

import {isNotNil} from 'ramda-adjunct';

import i18n from '@dms/i18n';

import {TestIdProps} from 'shared/web';

import {useEntityNavigation} from '../../../hooks/useEntityNavigation';
import {NavigationButton} from './NavigationButton';

interface EntityHeaderBackButtonProps extends TestIdProps {
  children?: ReactNode;
}

export function EntityHeaderBackButton(props: EntityHeaderBackButtonProps) {
  const {handleBreadcrumb, isBreadcrumbVisible} = useEntityNavigation();

  return (
    <Show when={isBreadcrumbVisible || isNotNil(props.children)}>
      <HStack align="center">
        <Show when={isBreadcrumbVisible}>
          <NavigationButton
            aria-label={i18n.t('general.actions.back')}
            data-testid={props['data-testid']}
            icon="navigation/arrow_back"
            onClick={handleBreadcrumb}
          />
        </Show>
        <Space fillAvailable />
        {props.children}
      </HStack>
      <Space vertical={3} />
    </Show>
  );
}
